export const INSTANCEDETAIL = 'INSTANCEDETAIL'